/**
 * @file        src/pages/BookingDetailsPage.jsx
 * @description Full-page view of a booking's Details drawer — what the drawer's
 *              full-screen button opens in a new tab. One wrapper for all three
 *              products: it renders the product's own drawer with `page`, so the
 *              page and the popup can never show different things. The B2C /
 *              Corporate origin rides on `?from=corporate` (lib/docOrigin.js),
 *              the same provenance the invoice / ticket pages use, so the
 *              sidebar opens the right group and Close returns to the right list.
 * @author      Kinetika Labs
 * @created     2026-10-09
 * @changelog
 *   - 2026-10-09 Claude — Initial.
 */
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import FlightDetails from './flight/BookingDetailsDrawer';
import HotelDetails from './hotel/BookingDetailsDrawer';
import InsuranceDetails from './insurance/BookingDetailsDrawer';
import { backToList, isCorporateOrigin } from '../lib/docOrigin';

const DRAWERS = { flight: FlightDetails, hotel: HotelDetails, insurance: InsuranceDetails };

export default function BookingDetailsPage({ product }) {
  const { id } = useParams();
  const { search } = useLocation();
  const navigate = useNavigate();
  const Drawer = DRAWERS[product];
  const bookingId = Number(id);
  const list = backToList(search, `/${product}/bookings`, `/${product}/corporate-bookings`);

  if (!Drawer || !Number.isInteger(bookingId) || bookingId <= 0) {
    return <div className="panel glass" style={{ padding: 24 }}>Booking not found.</div>;
  }
  return (
    <Drawer
      page
      bookingId={bookingId}
      audience={isCorporateOrigin(search) ? 'b2b' : 'b2c'}
      onClose={() => navigate(list)}
    />
  );
}
